var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEventSchedule = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  width: 26,
  height: 26,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2V5",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2V5",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 9.08997H20.5",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.37 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5V13",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9955 13.7H12.0045",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.29431 13.7H8.30329",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.29431 16.7H8.30329",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.02 2.90991C8.70997 2.90991 6.01997 5.59991 6.01997 8.90991V11.7999C6.01997 12.4099 5.75997 13.3399 5.44997 13.8599L4.29997 15.7699C3.58997 16.9499 4.07997 18.2599 5.37997 18.6999C9.68997 20.1399 14.34 20.1399 18.65 18.6999C19.86 18.2999 20.39 16.8699 19.73 15.7699L18.58 13.8599C18.28 13.3399 18.02 12.4099 18.02 11.7999V8.90991C18.02 5.60991 15.32 2.90991 12.02 2.90991Z",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  style: {
    transform: "translate(10px, 10px) scale(0.6)"
  },
  strokeWidth: 2,
  stroke: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style: {
    transform: "translate(10px, 10px) scale(0.6)"
  },
  strokeWidth: 2,
  stroke: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601",
  strokeMiterlimit: 10,
  style: {
    transform: "translate(10px, 10px) scale(0.6)"
  },
  strokeWidth: 2,
  stroke: "#fff"
}));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEventSchedule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/event-schedule.a8c7aea5.svg";
export { ForwardRef as ReactComponent };